import apiService from './api';

const analyticsService = {
  /**
   * Get daily analytics data using the corrected /admin/daily-analytics/ endpoint
   */
  async getDailyAnalytics(options = {}) {
    const normalizedOptions = typeof options === 'number' ? { days: options } : (options || {});
    const { days, month, year, startDate, endDate } = normalizedOptions;
    const params = new URLSearchParams();

    if (days != null) params.append('days', days);
    if (month != null) params.append('month', month);
    if (year != null) params.append('year', year);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    try {
      console.log('Fetching daily analytics with options:', normalizedOptions);
      
      // Use the fixed /admin/daily-analytics/ endpoint
      const response = await apiService.get(`/admin/daily-analytics/${params.toString() ? `?${params.toString()}` : ''}`);
      console.log('Daily analytics response:', response);
      
      // Handle paginated response
      let results = [];
      if (response && response.results && Array.isArray(response.results)) {
        results = response.results;
      } else if (Array.isArray(response)) {
        results = response;
      }
      
      // Transform the data to match expected frontend format
      const transformedResults = results.map(day => ({
        date: day.date,
        total_profit: parseFloat(day.total_profit || 0).toFixed(2),
        total_commission: parseFloat(day.total_commission || 0).toFixed(2),
        commission: parseFloat(day.total_commission || 0).toFixed(2), // Alias for compatibility
        deposits_count: day.deposits_count || 0,
        deposits_amount: parseFloat(day.deposits_amount || 0).toFixed(2),
        withdrawals_count: day.withdrawals_count || 0,
        withdrawals_amount: parseFloat(day.withdrawals_amount || 0).toFixed(2),
        new_users: day.new_users || 0,
        new_accounts: day.new_accounts || 0,
        updated_users: day.updated_users || 0,
        active_accounts: day.active_accounts || 0,
        total_balance: parseFloat(day.total_balance || 0).toFixed(2),
        transactions_count: day.updated_users || 0 // Use updated_users as transaction count
      }));
      
      console.log('Transformed daily analytics:', transformedResults);
      
      return {
        count: transformedResults.length,
        results: transformedResults
      };
    } catch (error) {
      console.error('Error fetching daily analytics:', error);
      
      // Fallback to empty data instead of throwing error
      return {
        count: 0,
        results: []
      };
    }
  },
  
  /**
   * Get monthly analytics using available endpoints
   */
  async getMonthlyAnalytics(year) {
    const months = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const targetYear = year || currentYear;
    
    // Get data for each month
    for (let month = 1; month <= 12; month++) {
      // Only get data up to current month if current year
      if (targetYear === currentYear && month > currentDate.getMonth() + 1) {
        break;
      }
      
      try {
        const response = await apiService.get(`/accounts/daily-summary/?month=${month}&year=${targetYear}`);
        months.push({
          month: `${targetYear}-${String(month).padStart(2, '0')}`,
          total_balance: response.total_balance || 0,
          average_balance: response.average_balance || 0,
          // Additional fields would need other endpoints
          total_profit: "0.00",
          total_commission: "0.00",
          total_deposits: "0.00",
          total_withdrawals: "0.00",
          active_users: 0,
          new_users: 0
        });
      } catch (error) {
        console.error(`Error fetching data for ${targetYear}-${month}:`, error);
      }
    }
    
    return months;
  }
};

export default analyticsService;